<template>
	<div v-if="displayDataEdit && ((!mode && viewMode) || mode)" class="schedule-phase-view">
		<div v-if="!mode && viewMode" style="display: flex; justify-content: space-between;">
			<b-button
				v-if="!mode"
				v-b-toggle="className"
				block
				class="panel-item-header-button"
			>
				<div style="display: flex">
					<span class="panel-item-header-trigger-icon" />
					<span class="panel-item-header-title">
						<h5> {{ title | capitalizeFirstLetter }} </h5> 
					</span>
				</div>
			</b-button>
			<div style="margin-top: 5px;">
				<b-icon
					v-if="displayMark === 1"
					class="h4 mb-2"
					icon="check-circle-fill"
					variant="secondary"
					style="margin-right: 20px;"
				/>
				<b-icon
					v-if="displayMark === 2"
					class="h4 mb-2"
					icon="check-circle-fill"
					variant="success"
					style="margin-right: 20px;"
				/>
				<b-icon
					v-if="displayMark === 3"
					class="h4 mb-2"
					icon="exclamation-circle-fill"
					variant="warning"
					style="margin-right: 20px;"
				/>
				<b-icon 
					v-b-tooltip.hover.top="formatDate(displayDataEdit[title + 'PhaseAsOfDate'])"
					icon="clock"
					style="margin-bottom: 0.7rem !important;"
				/>
			</div>
		</div>
		<div v-if="!mode && viewMode">
			<b-collapse :id="className">
				<b-container>
					<b-row> 
						<b-col>
							<div> Projected Start </div>
							<hr style="border-top: 1px solid rgba(0, 0, 0); margin: 0px;">
							<div style="text-align: right">
								{{ displayDataEdit[title + "PhaseProjectedStart"] | formatDate }}
							</div>
						</b-col>

						<b-col>
							<div> Actual Start </div>
							<hr style="border-top: 1px solid rgba(0, 0, 0); margin: 0px;">
							<div style="text-align: right">
								{{ displayDataEdit[title + "PhaseActualStart"] | formatDate }}
							</div>
						</b-col>
					</b-row>

					<b-row> 
						<b-col>
							<div> Projected End </div>
							<hr style="border-top: 1px solid rgba(0, 0, 0); margin: 0px;">
							<div style="text-align: right">
								{{ displayDataEdit[title + "PhaseProjectedEnd"] | formatDate }}
							</div>
						</b-col>

						<b-col>
							<div> Actual End </div>
							<hr style="border-top: 1px solid rgba(0, 0, 0); margin: 0px;">
							<div style="text-align: right">
								{{ displayDataEdit[title + "PhaseActualEnd"] | formatDate }}
							</div>
						</b-col>
					</b-row>

					<b-row>
						<b-col style="height: 15px" />
					</b-row>
				</b-container>
			</b-collapse>

			<div>
				Projected Completion %
				<b-progress :value="displayDataEdit[title + 'PhaseProjectedCompletionPct']" :max="100" class="mb-3" />
			</div>
			<div>
				Actual Completion %
				<b-progress :value="displayDataEdit[title + 'PhaseActualCompletionPct']" :max="100" class="mb-3" />
			</div>
		</div>

		<div v-if="mode">
			<b-container>
				<b-row> 
					<b-col>
						<h5> {{ title | capitalizeFirstLetter }} </h5>
					</b-col>
					<b-col>
						<b-form-datepicker
							:id="'datepicker_phase_asofdate_' + title"
							v-model="displayDataEdit[title + 'PhaseAsOfDate']"
							size="sm" 
							locale="en" 
							placeholder="No date selected"
							:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
						/>
					</b-col>
				</b-row>

				<b-row> 
					<b-col>
						Projcted Phase Start
						<b-form-datepicker
							:id="'datepicker_phase_projected_start_' + title"
							v-model="displayDataEdit[title + 'PhaseProjectedStart']"
							size="sm" 
							locale="en" 
							placeholder="No date selected"
							:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
						/>
					</b-col>
					<b-col>
						Actual Phase Start
						<b-form-datepicker
							:id="'datepicker_phase_actual_start_' + title"
							v-model="displayDataEdit[title + 'PhaseActualStart']"
							size="sm" 
							locale="en" 
							placeholder="No date selected"
							:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
						/>
					</b-col>
				</b-row>

				<b-row> 
					<b-col>
						Projcted Phase End
						<b-form-datepicker
							:id="'datepicker_phase_projected_end_' + title"
							v-model="displayDataEdit[title + 'PhaseProjectedEnd']"
							size="sm" 
							locale="en" 
							placeholder="No date selected"
							:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
						/>
					</b-col>
					<b-col>
						Actual Phase End
						<b-form-datepicker
							:id="'datepicker_phase_actual_end_' + title"
							v-model="displayDataEdit[title + 'PhaseActualEnd']"
							size="sm" 
							locale="en" 
							placeholder="No date selected"
							:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
						/>
					</b-col>
				</b-row>

				<b-row> 
					<b-col>
						Projected Phase Completion %
						<b-form-input
							id="input-phase-projected-completion-pct"
							v-model="displayDataEdit[title+ 'PhaseProjectedCompletionPct']"
							size="sm"
							type="number"
							placeholder=""
						/>
					</b-col>
				</b-row>

				<b-row> 
					<b-col>
						Actual Phase Completion %
						<b-form-input
							id="input-phase-actual-completion-pct"
							v-model="displayDataEdit[title+ 'PhaseActualCompletionPct']"
							size="sm"
							type="number"
							placeholder=""
						/>
					</b-col>
				</b-row>
			</b-container>
		</div>
	</div>
</template>

<script>
export default {
    name: 'SchedulePhaseView',
	components: {},
    filters: {
		formatDate(date) {
			if (!date || date === '') return 'Not updated'
			return new Date(date).toISOString().slice(0, 10);
		},
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
	},
	props: {
        title: {
            type: String,
            required: true,
        },
        data: {
            type: Object,
            required: true
        },
        mode: {
            type: Boolean,
            required: true
        }
	},   
    data() {
        return {
            className: `${this.title  }_collapse`,
			editMode: false,
            displayMark: 0,
			displayDataEdit: {},
			viewMode: false,
			options: [
				{ text: 'Planning', value: 'Planning' },
				{ text: 'Design', value: 'Design' },
				{ text: 'Construction', value: 'Construction' },
				{ text: 'Stabilization', value: 'Stabilization' },
				{ text: 'Steady-State', value: 'Steady-State' }
			]
        }
    },
    computed: {
		formatDate() {
			return date => (!date || date === '') ? `Not updated`: 
			(
				console.log(date), new Intl.DateTimeFormat('en-US', { dateStyle: 'long' }).format(new Date(date.replace(/-/g, '/').replace(/T.+/, ''))) 
			)
		}
	},
    watch: {
		displayDataEdit: {
			deep: true,
			handler() {
				this.viewMode = false;
                if (this.displayDataEdit[`${this.title}PhaseProjectedCompletionPct`] === 0 || this.displayDataEdit[`${this.title}PhaseActualCompletionPct`] === 0 ) {
                    this.displayMark = 1;	// secondary
                } else if (this.displayDataEdit[`${this.title}PhaseActualCompletionPct`] >= this.displayDataEdit[`${this.title}PhaseProjectedCompletionPct`]) {
					this.displayMark = 2;	// success
				} else {
					this.displayMark = 3;	// warning
				} 

				if (this.displayDataEdit[`${this.title}PhaseProjectedCompletionPct`] !== 0 || this.displayDataEdit[`${this.title}PhaseActualCompletionPct`] !== 0 
					|| this.displayDataEdit[`${this.title}PhaseAsOfDate`] || this.displayDataEdit[`${this.title}PhaseProjectedStart`]
					|| this.displayDataEdit[`${this.title}PhaseProjectedEnd`] || this.displayDataEdit[`${this.title}PhaseActualStart`]
					|| this.displayDataEdit[`${this.title}PhaseActualEnd`]) {
					this.viewMode = true;
				}

				this.updateData();
			},
		},
		data: {
			immediate: true,
			handler(newVal) {
				this.displayDataEdit = newVal;
			},
		},
        mode: {
			immediate: true,
			handler(newVal) {
				this.editMode = newVal;

				this.viewMode = false;
                if (this.displayDataEdit[`${this.title}PhaseProjectedCompletionPct`] === 0 || this.displayDataEdit[`${this.title}PhaseActualCompletionPct`] === 0 ) {
                    this.displayMark = 1;
                } else if (this.displayDataEdit[`${this.title}PhaseActualCompletionPct`] >= this.displayDataEdit[`${this.title}PhaseProjectedCompletionPct`]) {
					this.displayMark = 2;
				} else {
					this.displayMark = 3;
				} 

				if (this.displayDataEdit[`${this.title}PhaseProjectedCompletionPct`] !== 0 || this.displayDataEdit[`${this.title}PhaseActualCompletionPct`] !== 0 
					|| this.displayDataEdit[`${this.title}PhaseAsOfDate`] || this.displayDataEdit[`${this.title}PhaseProjectedStart`]
					|| this.displayDataEdit[`${this.title}PhaseProjectedEnd`] || this.displayDataEdit[`${this.title}PhaseActualStart`]
					|| this.displayDataEdit[`${this.title}PhaseActualEnd`]) {
					this.viewMode = true;
				}
			},
		}
	},
	created() {
	},
    mounted() {
	},
    methods: {
		async updateData() {
            if (this.displayDataEdit && this.displayDataEdit.id) {
				const postAssetScheduleModelData = await this.axios.patch(
					`/assetschedules/${this.displayDataEdit.id}`,
					this.displayDataEdit
				);
			}
		}
    }
};
</script>

<style scoped>
.btn {
	border: none;
    outline: none;
}
.btn:focus {
    box-shadow: none;
	outline: none;
}
.btn:focus-visible {
    outline: 0;
    border-radius: 0;
}
.btn:hover {
    color: #fff;
    text-decoration: none;
}
.btn-secondary {
	border: none;
    outline: none;
}
.btn-secondary:focus {
    background-color: transparent;
    border-color: transparent;
    box-shadow: none;
	outline: 0;
}
.btn-secondary:hover {
    color: #fff;
    background-color: transparent;
    border-color: transparent;
	outline: none;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
    color: #fff;
    background-color: transparent;
    border-color: transparent;
	outline: none;
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
    box-shadow: none;
}
.btn-secondary:focus-visible {
    outline: 0;
    border-radius: 0;
}
.panel-item-header-button {
    background-color: transparent;
    width: 70%;
}
.panel-item-header-title {
    bottom: 2px;
}
div.schedule-phase-view {
    border-radius: 12px;
    border: 1px solid #000000;
    padding: 10px;
	background-color: #ffffff;
	margin-bottom: 15px;
}
</style>

<style lang="scss">
</style>